import * as types from "../actions/types";
/*******************
@purpose : Intital home reducer data
@Author : INIC
******************/
const initialState = {
  userFavoriteDetails: {
    data: [],
    links: "",
  },
};

/*******************
@purpose : Card Details Reducer
@Parameter : {ini_data, action}
@Author : INIC
******************/
export default function userfavorite(ini_data = initialState, action = {}) {
  switch (action.type) {
    case types.CLEAR_USER_FAVORITE_DATA:
      return Object.assign({}, ini_data, {
        userFavoriteDetails: {
          data: [],
          links: "",
        },
      });

    case types.USER_FAVORITE_DATA:
      if (ini_data.userFavoriteDetails.data.length > 0) {
        return Object.assign({}, ini_data, {
          userFavoriteDetails: {
            data: ini_data.userFavoriteDetails.data.concat(action.data.data),
            links: action.data.links,
          },
        });
      } else {
        return Object.assign({}, ini_data, {
          userFavoriteDetails: {
            data: action.data.data,
            links: action.data.links,
          },
        });
      }

    default:
      return ini_data;
  }
}
